import { Injectable } from '@angular/core';
import { MonModalService } from '@client/app/modules/modals/services/mon-modal/mon-modal.service';
import { TranslateService } from '@client/app/services/translate/translate.service';
import { MonEventService } from '@monsido/services/mon-event/mon-event.service';
import { ToastService } from '@monsido/angular-shared-components';
import { AssignedProfilesObsService } from '../assigned-profiles-obs/assigned-profiles-obs.service';
import { PagePerformanceService } from '../page-performance/page-performance.service';
import { MON_EVENTS } from '@monsido/core/constants/mon-events.constant';
import { contextTokens } from '@monsido/services/request-auxiliary/request-auxiliary.service';
import {
    PagePerformanceRescanRepoService,
} from '@client/app/services/api/page-performance/page-performance-rescan-repo/page-performance-rescan-repo.service';
import {
    FormPagePerformancePageComponent,
} from '@client/app/modules/page-performance/forms/page/form-page-performance-page.component';


@Injectable({
    providedIn: 'root',
})
export class AssignProfileService {
    private rescanProfileStarted = false;

    constructor (
        private pagePerformanceService: PagePerformanceService,
        private monModalService: MonModalService,
        private translateService: TranslateService,
        private monEventService: MonEventService,
        private rescanRepoService: PagePerformanceRescanRepoService,
        private toastService: ToastService,
        private assignedProfilesObsService: AssignedProfilesObsService,
    ) {}

    assignProfile (page: { id: number }): Promise<void> {
        return new Promise<void>((resolve) => {
            const assignedProfilesCount = this.assignedProfilesObsService.assignedProfilesCount;
            if (this.pagePerformanceService.getMaxPageCount() <= assignedProfilesCount) {
                this.getReachedMaximumPageMessageDialog();
                resolve();
            } else {
                const params = {
                    body: FormPagePerformancePageComponent,
                    size: 'md',
                    data: {
                        page: page,
                    },
                };
                const callback = (assignedProfile: any) => {
                    if (assignedProfile) {
                        let chain = Promise.resolve();
                        assignedProfile.profile_ids.forEach((profileId: number) => {
                            chain = chain.then(
                                () => {
                                    this.rescanProfileStarted = true;
                                    return this.rescanProfile(page.id, profileId);
                                },
                            ).finally(() => {
                                resolve();
                            });
                        });

                        chain.finally(() => {
                            this.monEventService.run('pagePerformanceRefreshProfiles');
                            this.rescanProfileStarted = false;
                        });
                    } else {
                        resolve();
                    }
                };
                this.monEventService.run(MON_EVENTS.LOAD_DIALOG, { params, callback });
            }
        });
    }

    rescanProfile (pageId: number, profileId: number): Promise<any> {
        const params = {
            page_id: pageId,
            profile_id: profileId,
        };
        return this.rescanRepoService.create(params, contextTokens.NO_GLOBAL);
    }

    isRescanProfileStarted (): boolean {
        return this.rescanProfileStarted;
    }

    getReachedMaximumPageMessageDialog (): void {
        const text = this.translateService.getString(
            'You have reached the maximum number of Performance pages in your current plan.<br/><br/>To inquire about pricing options for additional pages, please press the button "Request quote for more pages" and someone on our team will be in touch.',
            {
                newLine: '<br/>',
            },
        );

        this.monEventService.run('actionTrigger', { action: 'maximum-number-of-pages-confirm-shown' });
        this.monModalService.customDialog({
            title: '',
            message: text,
            buttons: [
                {
                    label: this.translateService.getString('Cancel'),
                    className: 'btn btn-default btn-secondary',
                    callback: () => {
                        this.monEventService.run('actionTrigger', { action: 'maximum-number-of-pages-confirm-rejected' });
                    },
                },
                {
                    label: this.translateService.getString('Request quote for more pages'),
                    className: 'btn btn-mon-primary',
                    callback: () => {
                        this.requestMorePages();
                    },
                },
            ],
        }, {}).catch(() => {});
    }

    requestMorePages (): void {
        this.monEventService.run('actionTrigger', { action: 'maximum-number-of-pages-confirm-confirmed' });
        this.pagePerformanceService.requestMorePages(this.translateService.getString('Contact me about more Performance Pages'))
            .then(() => {
                this.toastService.success(this.translateService.getString('Our team has been notified of your request. We will soon be in touch.'));
            });
    }
}
